// import {
//     Env
// } from './env.js';
export class ResizeElem {
    constructor() {
        this.toggleMenus = {};
    }

    getStyle(e, styleName) {
        var styleValue = "";
        if (document.defaultView && document.defaultView.getComputedStyle) {
            styleValue = document.defaultView.getComputedStyle(e, "").getPropertyValue(styleName);
        } else if (e.currentStyle) {
            styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });
            styleValue = e.currentStyle[styleName];
        }
        return styleValue.replace(/px/g, '');
    }

    setProps(el, props) {
        for (let key in props) {
            el.style.setProperty('--' + key, props[key]);
        }
    };

    init() {
        // 環境
        //this.env = new Env();
        //this.env.detectEnv();

        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];
    }

    resizing() {
        let nowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
        let nowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);
        let windowSizeChanged = false;

        //ウインドウサイズが変わった場合のみ実行したい
        if (this.html.classList.contains('os-ios') || this.html.classList.contains('os-android')) {
            //モバイルは幅のみで判定、高さはスクロール時にURLバーの大きさが変わる
            if (this.windowWidth !== nowWidth) {
                windowSizeChanged = true;
                //console.log('window size changed SP');
            }
        } else {
            //PC高さも
            if (this.windowWidth !== nowWidth || this.windowWeight !== nowHeight) {
                windowSizeChanged = true;
                //console.log('window size changed PC');
            }
        }

        if (windowSizeChanged) {
            //console.log('resizing: window size changed');

            //.js-branding-chartに高さを指定(.js-branding-chartの高さ + branding-content__slideで一番大きい高さ)
            if (document.getElementById('branding-tab')) {
                let target = document.getElementById('branding-tab');
                let addPropElem = target.querySelector('.js-branding-chart');
                //console.log(addPropElem);
                addPropElem.style = null;

                //高さ計算
                let contentHeight1 = document.getElementById('branding-tab').querySelector('.js-branding-chart').clientHeight;
                let contentHeight2 = 0;
                let elems = document.getElementById('branding-tab').querySelectorAll('.js-tab-content-chart.is-show .branding-content__slide');

                //console.log(elems);
                for (let i = 0; i < elems.length; i++) {
                    let gridHeight = elems[i].clientHeight;
                    console.log(gridHeight);
                    if(contentHeight2 < gridHeight){
                        contentHeight2 = gridHeight;
                    }
                }

                // css
                let props = {
                    'content-height': contentHeight1 + contentHeight2,
                }
                this.setProps(addPropElem, props);
                
            }


            this.windowWidth = nowWidth;
            this.windowWeight = nowHeight;
        }


        let windowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);

        // ------------
        // company memberスライダー
        if (document.getElementById('member-scrolling')) {
            let memberSlider = document.getElementById('member-scrolling');

            // スライダー
            let memberSliderContents = document.querySelector('.js-member-scroller-sidemove');

            if(windowWidth > 700 && this.html.classList.contains('ratio-vertical')){
                //タブレット（縦長で幅700以上）では横スクロールしない
                memberSliderContents.style = null;
                memberSlider.classList.add('is-tablet-vertical--no-scroll');
            }else{
                memberSlider.classList.remove('is-tablet-vertical--no-scroll');
            }
        }

        //footer
        if(document.querySelectorAll('.footer-logo_loop').length > 0){
            const el = document.querySelector('.footer-logo_loop');
            let props = {
                'window-width': windowWidth,
            }
            this.setProps(el, props)
        }

        // -------------
        // branding chart スライダー
        if (document.getElementById('branding-tab')) {
            // tabボタンの表示: Tab縦,PCの時はtabボタンを画面内にsticky
            if((windowWidth > 700 && this.html.classList.contains('ratio-vertical')) || (this.html.classList.contains('ratio-horisontal'))){
                document.getElementById('branding-tab') .classList.add('is-sticky--tabs');
            }
        }

        // -------------
        // worksスライダー(indexページ、worksページ)
        if (document.getElementById('works-scrolling')) {
            if(windowWidth > 700 && this.html.classList.contains('ratio-horisontal')){
                document.getElementById('works-scrolling').classList.remove('is-tablet-vertical--no-scroll');
            }else{
                document.getElementById('works-scrolling').classList.add('is-tablet-vertical--no-scroll');
            }
        }
    }

}